import { formatLengthToArchitecturalString } from '@paragon/client-tools';
import { getLumberDescription } from '@paragon/contract-library';

import { MissingLumberPriceRow, MissingPlatePriceRow } from '../../../../store/slices/optimizationSettingsSlice';

/** Lumber includes stock length since a grade can appear at several. */
export function getUnpricedMaterialsWithoutDefaults(
  lumberRows: readonly MissingLumberPriceRow[],
  plateRows: readonly MissingPlatePriceRow[],
): string[] {
  return [
    ...lumberRows
      .filter((row) => row.defaultPricePerThousandBoardFeet == null && row.price == null)
      .map(
        (row) => `${getLumberDescription(row.lumber)} (${formatLengthToArchitecturalString(row.stockLengthInInches)})`,
      ),
    ...plateRows.filter((row) => row.defaultPricePerPound == null && row.price == null).map((row) => row.plateType),
  ];
}
